// Debug logging utility
// All console.logs should go through this to be gated by VITE_DEBUG
// In production builds, these are no-ops to prevent memory leaks from console spam

const DEBUG = import.meta.env.VITE_DEBUG === 'true';

// No-op functions for production
const noop = () => {};

// Debug logger - only logs when VITE_DEBUG=true
export const debug = DEBUG ? console.log.bind(console) : noop;

// Styled debug for important events (still gated)
export const debugStyled = DEBUG
  ? (message, style) => console.log(message, style)
  : noop;

// Warning logger - these we might want to keep in production for errors
export const debugWarn = DEBUG ? console.warn.bind(console) : noop;

// Error logger - always enabled, these are real problems
export const debugError = console.error.bind(console);

// Grouped logging for complex objects
export const debugGroup = DEBUG
  ? (label, fn) => {
      console.group(label);
      fn();
      console.groupEnd();
    }
  : noop;

// Conditional debug - only logs if condition is true AND debug is enabled
export const debugIf = (condition, ...args) => {
  if (DEBUG && condition) {
    console.log(...args);
  }
};

export default { debug, debugStyled, debugWarn, debugError, debugGroup, debugIf };
